import { render, staticRenderFns } from "./Radar.vue?vue&type=template&id=646d5a08&scoped=true&"
import script from "./Radar.vue?vue&type=script&lang=js&"
export * from "./Radar.vue?vue&type=script&lang=js&"
import style0 from "./Radar.vue?vue&type=style&index=0&id=646d5a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646d5a08",
  null
  
)

export default component.exports